var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82255 4.93815H3.84635L4.67969 5.74544C4.87066 5.93642 4.96615 6.15777 4.96615 6.40951C4.96615 6.66124 4.87066 6.8826 4.67969 7.07357C4.48872 7.26454 4.26736 7.36437 4.01562 7.37305C3.76389 7.38173 3.54253 7.29058 3.35156 7.09961L0.903646 4.65169C0.712673 4.46704 0.617188 4.25161 0.617188 4.00539C0.617188 3.75917 0.711476 3.54178 0.900052 3.3532L3.35156 0.901692C3.54253 0.71072 3.76389 0.615234 4.01562 0.615234C4.26736 0.615234 4.48872 0.71072 4.67969 0.901692C4.87066 1.09266 4.96615 1.31402 4.96615 1.56575C4.96615 1.81749 4.87066 2.03885 4.67969 2.22982L3.84635 3.06315H6.82255C7.08606 3.06315 7.30694 3.1543 7.48521 3.33659C7.66347 3.51888 7.7526 3.74207 7.7526 4.00615C7.7526 4.27021 7.66347 4.49156 7.48521 4.67021C7.30694 4.84884 7.08606 4.93815 6.82255 4.93815Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIconLeft);
export default __webpack_public_path__ + "static/media/carousel-icon-left.f1660f2a341785aca9ef1eb62f451953.svg";
export { ForwardRef as ReactComponent };